// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JM9oojuT546MCay3qLAg{color:var(--content-negative-primary)}.nfZk84n1TuMMPkfnCmGA{color:var(--content-primary-tertiary);font-size:13px;font-weight:400}.NIqPF2ObNkOX2D0udOcg{background-color:#fff}.guLKxgxl2ocaN2WQjgAs{border-top:1px var(--border-neutral-default)solid;padding:5px 0}.guLKxgxl2ocaN2WQjgAs.XaFDlHnV0SI8B3aPNUB1{display:none}.guLKxgxl2ocaN2WQjgAs .ZrkR4yy07gkV6Kgw58FN{justify-content:space-between;align-items:center;padding:2px 4px 2px 8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"warning": `JM9oojuT546MCay3qLAg`,
	"rightText": `nfZk84n1TuMMPkfnCmGA`,
	"textField": `NIqPF2ObNkOX2D0udOcg`,
	"textValues": `guLKxgxl2ocaN2WQjgAs`,
	"emptyList": `XaFDlHnV0SI8B3aPNUB1`,
	"value": `ZrkR4yy07gkV6Kgw58FN`
};
export default ___CSS_LOADER_EXPORT___;
